import { Box, styled } from '@mui/material';
import { breakpoints } from '@themes/theme.helpers';

export const StyledTableRow = styled(Box)<{ iscursorpointer?: string }>`
  display: contents;
  .link,
  .link > span {
    display: contents;
    &:hover > div {
      background-color: #e2e9ea;
    }
  }
  cursor: ${(props) => (props.iscursorpointer === 'true' ? 'pointer' : 'default')};
`;

export const StyledTableCell = styled(Box)<{ isbold?: string }>`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  padding: 2px;
  display: grid;
  grid-template-columns: minmax(100px, 1fr) minmax(100px, 2fr);
  grid-template-rows: auto;
  color: #1c1c1c;
  font-weight: ${(props) => props.isbold === 'true' && 700};
  ${breakpoints.up('md')} {
    display: block;
    line-height: 26px;
    padding: 12px;
    border-bottom: 1px solid #f3f4f7;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const StyledTableRowSeparator = styled(Box)`
  display: block;
  width: 100%;
  padding: 4px;
  border-bottom: 1px solid #f3f4f7;
  margin-bottom: 12px;
  ${breakpoints.up('md')} {
    display: none;
  }
`;

export const StyledCellHeader = styled(Box)`
  display: inline-block;
  font-weight: 700;
  margin-right: 8px;
  word-wrap: break-word;
  ${breakpoints.up('md')} {
    display: none;
  }
`;
